import { Routes, Route } from 'react-router-dom';
import { Container, Title, Text } from '@mantine/core';
import Home from './pages/Home';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import ProfilePage from './pages/ProfilePage';
import SellersPage from './pages/SellersPage';
import PrincessDetailPage from './pages/PrincessDetailPage';
import SellerRegistrationPage from './pages/SellerRegistrationPage';
import SellerDashboardPage from './pages/seller/SellerDashboardPage';
import SellerProducts from './pages/seller/SellerProducts';
import SubscriptionPage from './pages/SubscriptionPage';
import MessagesPage from './pages/MessagesPage';
import ConversationPage from './pages/ConversationPage';
import MySpecialRequestsPage from './pages/user/MySpecialRequestsPage';
import SpecialRequestsPage from './pages/seller/SpecialRequestsPage';

// Simple 404 component
const NotFound = () => (
  <Container size="sm" py="xl">
    <Title order={1}>404 - Page Not Found</Title>
    <Text mt="md" c="dimmed">The page you're looking for doesn't exist.</Text>
  </Container>
);

function App() {
  console.log('App component rendering, PrincessDetailPage:', PrincessDetailPage);
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="products" element={<ProductsPage />} />
      <Route path="products/:productId" element={<ProductDetailPage />} />
      <Route path="cart" element={<CartPage />} />
      <Route path="profile" element={<ProfilePage />} />
      <Route path="princesses" element={<SellersPage />} />
      <Route path="princess/:princessId" element={<PrincessDetailPage />} />
      <Route path="become-princess" element={<SellerRegistrationPage />} />
      <Route path="seller" element={<SellerDashboardPage />} />
      <Route path="seller/products" element={<SellerProducts />} />
      <Route path="subscription" element={<SubscriptionPage />} />
      <Route path="messages" element={<MessagesPage />} />
      <Route path="messages/:userId" element={<ConversationPage />} />
      <Route path="my-requests" element={<MySpecialRequestsPage />} />
      <Route path="seller/special-requests" element={<SpecialRequestsPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
